<script setup>

import LoaderIcon from '@/components/CustomIcons/LoaderIcon.vue';
import CoursesCarousel from '@/components/landing/courses/CoursesCarousel.vue';
</script>

<template>
  <div class="base-gradient py-8 md:py-24 sm:px-2 lg:px-4 text-md text-primary">
    <div class="mx-auto max-w-7xl px-6">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-3xl">
          <h2 class="text-3xl font-bold tracking-tight">
            {{ $t("landingPage.coursesSection.title") }}
          </h2>
        </div>
        <div class="mt-8 grid grid-cols-1 lg:grid-cols-[40%_60%] gap-x-12 gap-y-10 mb-12 items-center">
          <div>
            <h3 class="text-xl text-balance font-bold tracking-tight">
              {{ $t("landingPage.coursesSection.subtitle") }}
            </h3>
            <ul class="mt-4 list-disc list-outside pl-5">
              <li>{{ $t('landingPage.coursesSection.bullet1') }}</li>
              <li>{{ $t('landingPage.coursesSection.bullet2') }}</li>
              <li>{{ $t('landingPage.coursesSection.bullet3') }}</li>
              <li>{{ $t('landingPage.coursesSection.bullet4') }}</li>
              <li>{{ $t('landingPage.coursesSection.bullet5') }}</li>
            </ul>
          </div>

          <div class="w-full">
            <CoursesCarousel class="w-full h-[500px]" />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
